import Image from "next/image";

const CompanyOutlookSectionTopContent = () => {
  return (
    <div className="grid grid-cols-12 2xl:w-2/3 bg-primary-low-em/50 rounded-2xl overflow-hidden">
      <div className="col-span-12 md:col-span-7 flex flex-col items-center justify-center">
        <div className="flex flex-col items-start justify-center p-8 md:p-16 space-y-6">
          <Image src="/assets/icons/eye-gradient.png" width={48} height={48} alt="outlook" />

          <span className="mobile-h4 md:h5 lg:h4 text-primary-dark">Company Outlook</span>
          <span className="text-body-lg text-text-color-mid-em">
            At{" "}
            <span className="text-secondary-dark label-lg-bold">
              SimpleWaste
            </span>{" "}
            we’re positioned to expand our company and our reach. The innovation
            our technology brings to the industry extends beyond waste and
            recycling and merges into other facility-related services.
            <br /> <br />
            Your customers will reap the benefits of our strong position and
            leading-edge technology. Our expansion capabilities occupy no
            borders.
          </span>
        </div>
      </div>
      <div className="col-span-12 md:col-span-5 flex justify-end">
        <div
          className="min-h-[364px] h-full w-full bg-cover bg-right bg-no-repeat"
          style={{
            backgroundImage:
              "url('/images/acquisitions/company-outlook-01.jpg')",
          }}
        />
      </div>
    </div>
  );
};
export default CompanyOutlookSectionTopContent;
